const mutations = {
  GET_ITEMSELECT(state) {
    return state.itemSelect;
  },

  SET_ITEMSELECT(state, itemSelect) {
    state.itemSelect = itemSelect;
  },

  GET_FTS(state) {
    return state.fts;
  },

  SET_FTS(state, fts) {
    state.fts = fts;
  },
};

export default mutations;
